import { AvailableLanguages } from '@repo/toolkit/language-types'
import FilesSelection from '@repo/ui/files-selection'
import Typography from '@repo/ui/typography'
import { Fragment } from 'react/jsx-runtime'
import { useFormContext } from 'react-hook-form'

import i18n from '../../../../i18n'
import { TeflInput } from '../../../lib/types/models/tefl/tefl-input'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'

const TeflDocumentsForm = () => {
  const form = useFormContext<TeflInput>()

  return (
    <FormField
      control={form.control}
      name="documents"
      render={({ field }) => (
        <FormItem className="flex-1">
          <FormControl>
            <Fragment>
              <FilesSelection
                required
                title="TEFL documents"
                locale={i18n.language as AvailableLanguages}
                files={field.value ?? []}
                onFilesChange={(files) => form.setValue('documents', files)}
              />
              {form.formState.errors.documents?.message &&
                (!form.watch('documents') || form.watch('documents')?.length === 0) && (
                  <Typography variant="label-medium" className="text-red">
                    Please upload at least one document
                  </Typography>
                )}
            </Fragment>
          </FormControl>
        </FormItem>
      )}
    />
  )
}

export default TeflDocumentsForm
